export const rubros = [
    {
        
        "nombre": "01.-Normatividad",
        "icono": "Normatividad.png",
        "formatos": [
            {
                "nombre": "Marco Normativo",
                "xlsx": "a69_f01 SADERH.xlsx",
                "html": "a69_f01 SADERH.htm"
            },
        ]
    }, 
    {
        
        "nombre": "02.-Estructura",
        "icono":"Estructura.png",
        "formatos": [
            {
                "nombre": "Estructura Orgánica",
                "xlsx": "a69_f02_a SADERH.xlsx",
                "html": "a69_f02_a SADERH.htm"
            },
            {
                "nombre": "Organigrama",
                "xlsx": "a69_f02_b SADERH.xlsx",
                "html": "a69_f02_b SADERH.htm"
            }
        ]
    },
    {
        
        "nombre": "03.-Facultades",
        "icono":"Facultades.png",
        "formatos": [
            {
                "nombre": "Facultades",
                "xlsx": "a69_f03 SADERH.xlsx",
                "html": "a69_f03 SADERH.htm"
            }
        ]
    },
    {
        
        "nombre": "04.-Programas Operativos Anuales",
        "icono":"ProgramasOperativosAnuales.png",
        "formatos": [
            {
                "nombre": "Metas y Objetivos",
                "xlsx": "a69_f04 SADERH.xlsx",
                "html": "a69_f04 SADERH.htm"
            }
        ]
        
    },
    {
        
        "nombre": "05.-Indicadores de Interés",
        "icono":"IndicadoresInteres.png",
        "formatos": [
            {
                "nombre": "Indicadores de Interés",
                "xlsx": "a69_f5 SADERH.xlsx",
                "html": "a69_f5 SADERH.htm"
            }
        ]
        
    },
    {
        
        "nombre": "06.-Matriz de Indicadores",
        "icono":"MatrizIndicadores.png",
        "formatos": [
            {
                "nombre": "Matriz de Indicadores",
                "xlsx": "a69_f6 SADERH.xlsx",
                "html": "a69_f6 SADERH.htm"
            }
        ]
        
    },
    {
        
        "nombre": "07.-Directorio",
        "icono":"Directorio.png",
        "formatos": [
            {
                "nombre": "Directorio",
                "xlsx": "a69_f07 SADERH.xlsx",
                "html": "a69_f07 SADERH.htm"
            }
        ]
        
    },
    {
        
        "nombre": "08.-Sueldos",
        "icono":"Sueldos.png",
        "formatos": [
            {
                "nombre": "Remuneraciones",
                "xlsx": "0",
                "html": "0",
                "xlsx_liga": "https://oficialiamayor.hidalgo.gob.mx/Transparencia/xlsx/a69_f8_aOM.xlsx",
                "htm_liga": "https://oficialiamayor.hidalgo.gob.mx/Transparencia/htm/a69_f8_aOM.htm"
            },
            {
                "nombre": "Tabulador de Sueldos y Salarios",
                "xlsx": "0",
                "html": "0",
                "xlsx_liga": "https://oficialiamayor.hidalgo.gob.mx/Transparencia/xlsx/a69_f8_bOM.xlsx",
                "htm_liga": "https://oficialiamayor.hidalgo.gob.mx/Transparencia/htm/a69_f8_bOM.htm"
            }
        ]
        
    },
    {
        
        "nombre": "09.-Viáticos",
        "icono":"Viaticos.png",
        "formatos": [
            {
                "nombre": "Viáticos",
                "xlsx": "a69_f9 SADERH.xlsx",
                "html": "a69_f9 SADERH.htm"
            }
        ]	
    },
    {
        
        "nombre": "10.-Plazas",
        "icono":"Plazas.png","formatos": [
            {
                "nombre": "Total de Personal de Base y Confianza",
                "xlsx": "0",
                "html": "0",
                "xlsx_liga": "https://oficialiamayor.hidalgo.gob.mx/Transparencia/xlsx/a69_f10_aOM.xlsx",
                "htm_liga": "https://oficialiamayor.hidalgo.gob.mx/Transparencia/htm/a69_f10_aOM.htm"
            },
            {
                "nombre": "Total de las Plazas de Base y Confianza",
                "xlsx": "0",
                "html": "0",
                "xlsx_liga": "https://oficialiamayor.hidalgo.gob.mx/Transparencia/xlsx/a69_f10_bOM.xlsx",
                "htm_liga": "https://oficialiamayor.hidalgo.gob.mx/Transparencia/htm/a69_f10_bOM.htm"
            }
        ]	
    },
    {
        
        "nombre": "11.-Honorarios",
        "icono":"Honorarios.png",
        "formatos": [
            {
                "nombre": "Personal de Honorarios",
                "xlsx": "a69_f11 SADERH.xlsx",
                "html": "a69_f11 SADERH.htm"
            }
        ]	
    },
    {
        "nombre": "12.-Declaraciones Públicas",
        "icono":"DeclaracionesPublicas.png",
        "formatos": [
            {
                "nombre": "Declaraciones Patrimoniales",
                "xlsx": "0",
                "html": "0",
                "xlsx_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/xlsx/a69_f12_SC.xlsx",
                "htm_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/htm/a69_f12_SC.htm"    
            },
            // {
            //     "nombre": "Declaraciones Patrimoniales",
            //     "xlsx": "0",
            //     "html": "0",
            //     "xlsx_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/xlsx/a69_f12_SC_II.xlsx",
            //     "htm_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/htm/a69_f12_SC_II.htm"    
            // },
            // {
            //     "nombre": "Declaraciones Patrimoniales",
            //     "xlsx": "0",
            //     "html": "0",
            //     "xlsx_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/xlsx/a69_f12_SC_III.xlsx",
            //     "htm_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/htm/a69_f12_SC_III.htm"    
            // }
        ]	
    },
    {
        "nombre": "13.-Datos de Contacto de la Unidad",
        "icono":"DatosContactoUnidad.png",
        "formatos": [
            {
                "nombre": "Domicilio de la Unidad de Transparencia",
                "xlsx": "0",
                "html": "0",
                "xlsx_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/xlsx/a69_f13_SC.xlsx",
                "htm_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/htm/a69_f13_SC.htm"  
            }
        ]
    },
    {
        
        "nombre": "14.-Convocatorias",
        "icono":"Convocatorias.png",
        "formatos": [
            {
                "nombre": "Convocatorias a Concursos para Cargos Públicos",
                "xlsx": "0",
                "html": "0",
                "xlsx_liga": "https://oficialiamayor.hidalgo.gob.mx/Transparencia/xlsx/a69_f14OM.xlsx",
                "htm_liga": "https://oficialiamayor.hidalgo.gob.mx/Transparencia/htm/a69_f14OM.htm" 
            }
        ]
    },
    {
        
        "nombre": "15.-Programas Sociales",
        "icono":"ProgramasSociales.png",
        "formatos": [
            {
                "nombre": "Programas de Subsidio, Estimulo y Apoyo",
                "xlsx": "a69_f15_a SADERH.xlsx",
                "html": "a69_f15_a SADERH.htm"
            },
            {
                "nombre": "Padrón de beneficiarios",
                "xlsx": "a69_f15_b SADERH.xlsx",
                "html": "a69_f15_b SADERH.htm"
            }
        ]
    },
    {
        
        "nombre": "16.-Relaciones Laborales",
        "icono":"RelacionesLaborales.png",
        "formatos": [
            {
                "nombre": "Condiciones Generales de Trabajo",
                "xlsx": "0",
                "html": "0",
                "xlsx_liga": "https://oficialiamayor.hidalgo.gob.mx/Transparencia/xlsx/a69_f16_aOM.xlsx",
                "htm_liga": "https://oficialiamayor.hidalgo.gob.mx/Transparencia/htm/a69_f16_aOM.htm" 
            },
            {
                "nombre": "Recursos Públicos",
                "xlsx": "0",
                "html": "0",
                "xlsx_liga": "https://oficialiamayor.hidalgo.gob.mx/Transparencia/xlsx/a69_f16_bOM.xlsx",
                "htm_liga": "https://oficialiamayor.hidalgo.gob.mx/Transparencia/htm/a69_f16_bOM.htm" 
            }
        ]
    },
    {
        
        "nombre": "17.-Información Curricular",
        "icono":"InformacionCurricular.png",
        "formatos": [
            {
                "nombre": "Información Curricular",
                "xlsx": "a69_f17 SADERH.xlsx",
                "html": "a69_f17 SADERH.htm"
            }
        ]
    },
    {
        
        "nombre": "18.-Sanciones Administrativas",
        "icono":"SancionesAdministrativas.png",
        "formatos": [
            {
                "nombre": "Servidores Públicos Sancionados",
                "xlsx": "0",
                "html": "0",
                "xlsx_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/xlsx/a69_f18_SC.xlsx",
                "htm_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/htm/a69_f18_SC.htm" 
            }
        ]	
    },
    {
        
        "nombre": "19.-Servicios",
        "icono":"Servicios.png",
        "formatos": [
            {
                "nombre": "Servicios",
                "xlsx": "a69_f19 SADERH.xlsx",
                "html": "a69_f19 SADERH.htm"
            }
        ]
        
    },
    {
        
        "nombre": "20.-Trámites",
        "icono":"Tramites.png",
        "formatos": [
            {
                "nombre": "Trámites",
                "xlsx": "a69_f20 SADERH.xlsx",
                "html": "a69_f20 SADERH.htm"
            }
        ]
        
    },
    {
        
        "nombre": "21.-Presupuesto e Informes Trimestrales",
        "icono":"PresupuestoInformesTrimestrales.png",
        "formatos": [
            {
                "nombre": "Presupuesto Anual",
                "xlsx": "0",
                "html": "0",
                "xlsx_liga": "https://hacienda.hidalgo.gob.mx/files/transparencia/xlsx/2025/Primer%20Trimestre/a69_f21_a.xlsx",
                "htm_liga": "https://hacienda.hidalgo.gob.mx/files/transparencia/htm/2025/Primer%20Trimestre/a69_f21_a.htm" 
            },
            {
                "nombre": "Gasto Trimestral",
                "xlsx": "0",
                "html": "0",
                "xlsx_liga": "https://hacienda.hidalgo.gob.mx/files/transparencia/xlsx/2025/Cuarto%20Trimestre/a69_f21_b%20SH.xlsx",
                "htm_liga": "https://hacienda.hidalgo.gob.mx/files/transparencia/htm/2025/Cuarto%20Trimestre/a69_f21_b%20SH.htm" 
            },
            {
                "nombre": "Cuenta Pública",
                "xlsx": "0",
                "html": "0",
                "xlsx_liga": "https://hacienda.hidalgo.gob.mx/files/transparencia/xlsx/2025/Segundo%20Trimestre/a69_f21_c%20SH.xlsx",
                "htm_liga": "https://hacienda.hidalgo.gob.mx/files/transparencia/htm/2025/Segundo%20Trimestre/a69_f21_c%20SH.htm" 
            }
        ]
        
    },
    {
        
        "nombre": "22.-Deuda Pública",
        "icono":"DeudaPublica.png",
        "formatos": [
            {
                "nombre": "Deuda Pública",
                "xlsx": "0",
                "html": "0",
                "xlsx_liga": "https://hacienda.hidalgo.gob.mx/files/transparencia/xlsx/2025/Tercer%20Trimestre/a69_f22.xlsx",
                "htm_liga": "https://hacienda.hidalgo.gob.mx/files/transparencia/htm/2025/Tercer%20Trimestre/a69_f22.htm" 
            }
        ]
    },
    {
        
        "nombre": "23.-Comunicación Social y Publicidad",
        "icono":"ComunicacionSocialPublicidad.png",
        "formatos": [
            {
                "nombre": "Programa Anual de Comunicación Social",
                "xlsx": "a69_f23_a SADERH.xlsx",
                "html": "a69_f23_a SADERH.htm"
            },
            {
                "nombre": "Erogación de Recursos de Comunicación Social",
                "xlsx": "a69_f23_b SADERH.xlsx",
                "html": "a69_f23_b SADERH.htm"
            },
            {
                "nombre": "Tiempos Oficiales",
                "xlsx": "0",
                "html": "0",
                "xlsx_liga": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/RadioTVH/dir1/FC/a69_f23_c_RTH.xlsx",
                "htm_liga": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/RadioTVH/dir1/FC/a69_f23_c_RTH.htm"
            },
            

        ]
    },
    {
        
        "nombre": "24.-Resultados de Auditorías",
        "icono":"ResultadosAuditorias.png",
        "formatos": [
            {
                "nombre": "Auditorías",
                "xlsx": "0",
                "html": "0",
                "xlsx_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/xlsx/a69_f24_SC.xlsx",
                "htm_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/htm/a69_f24_SC.htm"
            }
        ]
    },
    {
        
        "nombre": "25.-Dictámines de Estados Financiero",
        "icono":"DictamenesFinancieros.png",
        "formatos": [
            {
                "nombre": "Estados Financieros",
                "xlsx": "0",
                "html": "0",
                "xlsx_liga": "https://hacienda.hidalgo.gob.mx/files/transparencia/xlsx/2025/Segundo%20Trimestre/a69_f25%20SH.xlsx",
                "htm_liga": "https://hacienda.hidalgo.gob.mx/files/transparencia/htm/2025/Segundo%20Trimestre/a69_f25%20SH.htm"
            }
        ]
        
    },
    {
        
        "nombre": "26.-Asignación de Recursos Públicos a Personas",
        "icono":"AsignacionRecursosPublicosPersonas.png",
        "formatos": [
            {
                "nombre": "Personas a Quienes se asignó Recursos Públcios",
                "xlsx": "0",
                "html": "0",
                 "xlsx_liga": "https://hacienda.hidalgo.gob.mx/files/transparencia/xlsx/2025/Tercer%20Trimestre/a69_f26.xlsx",
                "htm_liga": "https://hacienda.hidalgo.gob.mx/files/transparencia/htm/2025/Tercer%20Trimestre/a69_f26.htm"
            }
        ]
        
    },
    {
        
        "nombre": "27.-Concesiones",
        "icono":"Concesiones.png",
        "formatos": [
            {
                "nombre": "Concesiones, Contratos, Convenios, Permisos, Licencias y Autorizaciones",
                "xlsx": "a69_f27 SADERH.xlsx",
                "html": "a69_f27 SADERH.htm"
            }
        ]
        
    },
    {
        
        "nombre": "28.-Licitaciones Públicas",
        "icono":"LicitacionesPublicas.png",
        "formatos": [
            {
                "nombre": "Procedimientos de Adjudicación Directa, Licitación Pública e Invitación Restringida",
                "xlsx": "28-LGT_Art_70_Fr_XXVIII SADERH.xlsx",
                "html": "28-LGT_Art_70_Fr_XXVIII SADERH.htm",
            
            },
            
        ]
        
    },
    {
        
        "nombre": "29.-Informes",
        "icono":"Informes.png",
        "formatos": [
            {
                "nombre": "Informes",
                "xlsx": "0",
                "html": "0",
                "xlsx_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/xlsx/a69_f29_SC.xlsx",
                "htm_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/htm/a69_f29_SC.htm"
            }
        ]
        
    },
    {
        
        "nombre": "30.-Estadísticas Generadas",
        "icono":"EstadisticasGenerales.png",
        "formatos": [
            {
                "nombre": "Estadísticas",
                "xlsx": "a69_f30 SADERH.xlsx",
                "html": "a69_f30 SADERH.htm"
            }
        ]
        
    },
    {
        
        "nombre": "31.-Informe de Avances y Documentos Financiero",
        "icono":"InformeAvancesDocumentosFinancieros.png",
        "formatos": [
            {
                "nombre": "Informe de Estados Financieros",
                "xlsx": "0",
                "html": "0",
                "xlsx_liga": "https://hacienda.hidalgo.gob.mx/files/transparencia/xlsx/2025/Cuarto%20Trimestre/a69_f31_a%20SH.xlsx",
                "htm_liga": "https://hacienda.hidalgo.gob.mx/files/transparencia/htm/2025/Cuarto%20Trimestre/a69_f31_a%20SH.htm"
            },
            {
                "nombre": "Informe Contable, Presupuestal y Programático",
                "xlsx": "0",
                "html": "0",
                "xlsx_liga": "https://hacienda.hidalgo.gob.mx/files/transparencia/xlsx/2025/Cuarto%20Trimestre/a69_f31_b%20SH.xlsx",
                "htm_liga": "https://hacienda.hidalgo.gob.mx/files/transparencia/htm/2025/Cuarto%20Trimestre/a69_f31_b.htm"
            }
        ]
        
    },
    {
        
        "nombre": "32.-Padrón de Proveedores y Contratistas",
        "icono":"PadronProveedoresContratistas.png",
        "formatos": [
            {
                "nombre": "Padrón de Proveedores y Contratistas",
                "xlsx": "0",
                "html": "0",
                "xlsx_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/xlsx/a69_f32_SC.xlsx",
                "htm_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/htm/a69_f32_SC.htm"
            }
        ]
        
    },
    {
        
        "nombre": "33.-Convenios con Sectores Social y Privado",
        "icono":"ConveniosSectoresSocialPrivado.png",
        "formatos": [
            {
                "nombre": "Convenios de Coordinación y Concertación",
                "xlsx": "a69_f33 SADERH.xlsx",
                "html": "a69_f33 SADERH.htm"
            }
        ]
        
    },
    {
        
        "nombre": "34.-Inventario de Bienes",
        "icono":"InventarioBienes.png",
        "formatos": [
            {
                "nombre": "Inventario de Bienes Muebles",
                "xlsx": "0",
                "html": "0",
                "xlsx_liga": "https://oficialiamayor.hidalgo.gob.mx/Transparencia/xlsx/a69_f34_aOM.xlsx",
                "htm_liga": "https://oficialiamayor.hidalgo.gob.mx/Transparencia/htm/a69_f34_aOM.htm"
            },
            {
                "nombre": "Alta de Bienes Muebles",
                "xlsx": "0",
                "html": "0",
                "xlsx_liga": "https://oficialiamayor.hidalgo.gob.mx/Transparencia/xlsx/a69_f34_bOM.xlsx",
                "htm_liga": "https://oficialiamayor.hidalgo.gob.mx/Transparencia/htm/a69_f34_bOM.htm"
            },
            {
                "nombre": "Bajas de Bienes Muebles",
                "xlsx": "0",
                "html": "0",
                "xlsx_liga": "https://oficialiamayor.hidalgo.gob.mx/Transparencia/xlsx/a69_f34_cOM.xlsx",
                "htm_liga": "https://oficialiamayor.hidalgo.gob.mx/Transparencia/htm/a69_f34_cOM.htm"
            },
            {
                "nombre": "Inventario de Bienes Inmuebles",
                "xlsx": "0",
                "html": "0",
                "xlsx_liga": "https://oficialiamayor.hidalgo.gob.mx/Transparencia/xlsx/a69_f34_dOM.xlsx",
                "htm_liga": "https://oficialiamayor.hidalgo.gob.mx/Transparencia/htm/a69_f34_dOM.htm"
            },
            {
                "nombre": "Alta de Bienes Inmuebles",
                "xlsx": "0",
                "html": "0",
                "xlsx_liga": "https://oficialiamayor.hidalgo.gob.mx/Transparencia/xlsx/a69_f34_eOM.xlsx",
                "htm_liga": "https://oficialiamayor.hidalgo.gob.mx/Transparencia/htm/a69_f34_eOM.htm"
            },
            {
                "nombre": "Bajas de Bienes Inmuebles",
                "xlsx": "0",
                "html": "0",
                "xlsx_liga": "https://oficialiamayor.hidalgo.gob.mx/Transparencia/xlsx/a69_f34_fOM.xlsx",
                "htm_liga": "https://oficialiamayor.hidalgo.gob.mx/Transparencia/htm/a69_f34_fOM.htm"
            },
            {
                "nombre": "Donaciones de Bienes Muebles e Inmuebles",
                "xlsx": "0",
                "html": "0",
                "xlsx_liga": "https://oficialiamayor.hidalgo.gob.mx/Transparencia/xlsx/a69_f34_gOM.xlsx",
                "htm_liga": "https://oficialiamayor.hidalgo.gob.mx/Transparencia/htm/a69_f34_gOM.htm"
            }

        ]
        
    },
    {
        
        "nombre": "35.-Recomendaciones y Atención en Materia de Derechos Humanos",
        "icono":"RecomendacionesAtenciónMateriaDerechosHumanos.png",
        "formatos": [
            {
                "nombre": "Recomendaciones de Derechos Humanos Emitidas por la CNDH",
                "xlsx": "a69_f35_a SADERH.xlsx",
                "html": "a69_f35_a SADERH.htm"
            },
            {
                "nombre": "Recomendaciones de Derechos Humanos Casos Especiales",
                "xlsx": "a69_f35_b SADERH.xlsx",
                "html": "a69_f35_b SADERH.htm"
            },
            {
                "nombre": "Las Recomendaciones de Derechos Humanos Org. Int. CNDH",
                "xlsx": "a69_f35_c SADERH.xlsx",
                "html": "a69_f35_c SADERH.htm"
            },
        ]
        
    },
    {
        
        "nombre": "36.-Resoluciones y Laudos de Juicios",
        "icono":"ResolucionesLaudosJuicios.png",
        "formatos": [
            {
                "nombre": "Resoluciones y Laudos ",
                "xlsx": "0",
                "html": "0",
                "xlsx_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/xlsx/a69_f36_SC.xlsx",
                "htm_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/htm/a69_f36_SC.htm"
            }
        ]
        
    },
    {
        
        "nombre": "37.-Mecanismo de Participación Ciudadana",
        "icono":"MecanismosParticipacionCiudadana.png",
        "formatos": [
            {
                "nombre": "Mecanismos de Participación Ciudadana",
                "xlsx": "a69_f37_a SADERH.xlsx",
                "html": "a69_f37_a SADERH.htm"
            },
            {
                "nombre": "Resultados de los Mecanismos de Participación Ciudadana",
                "xlsx": "a69_f37_b SADERH.xlsx",
                "html": "a69_f37_b SADERH.htm"
            }
        ]
        
    },
    {
        
        "nombre": "38.-Programas Ofrecidos",
        "icono":"ProgramasOfrecidos.png",
        "formatos": [
            {
                "nombre": "Programas que Ofrecen",
                "xlsx": "a69_f38_a SADERH.xlsx",
                "html": "a69_f38_a SADERH.htm"
            },
            {
                "nombre": "Tramites a los Programas que Ofrecen",
                "xlsx": "a69_f38_b SADERH.xlsx",
                "html": "a69_f38_b SADERH.htm"
            }
        ]
        
    },
    {
        
        "nombre": "39.-Actas y Resoluciones del Comité de Transparencia",
        "icono":"ActasResolucionesComiteTransparencia.png",
        "formatos": [
            {
                "nombre": "Informe de Sesiones",
                "xlsx": "0",
                "html": "0",
                "xlsx_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/xlsx/a69_f39a_SC.xlsx",
                "htm_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/htm/a69_f39a_SC.htm"
            },
            {
                "nombre": "Informe de Resoluciones",
                "xlsx": "0",
                "html": "0",
                "xlsx_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/xlsx/a69_f39b_SC.xlsx",
                "htm_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/htm/a69_f39b_SC.htm"
            },
            {
                "nombre": "Actas Integrantes del Comité",
                "xlsx": "0",
                "html": "0",
                "xlsx_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/xlsx/a69_f39c_SC.xlsx",
                "htm_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/htm/a69_f39c_SC.htm"
            },
            {
                "nombre": "Calendario de Sesiones del comité",
                "xlsx": "0",
                "html": "0",
                "xlsx_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/xlsx/a69_f39d_SC.xlsx",
                "htm_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/htm/a69_f39d_SC.htm"
            }
        ]
        
    },
    {
        
        "nombre": "40.-Evaluacion y Encuesta a Programas Financiados con Recursos Públicos",
        "icono":"EvaluacionencuestasProgramas.png",
        "formatos": [
            {
                "nombre": "Evaluaciones",
                "xlsx": "0",
                "html": "0",
                "xlsx_liga": "https://hacienda.hidalgo.gob.mx/files/transparencia/xlsx/2025/Primer%20Trimestre/40-LGT_Art_70_Fr_XL.xlsx",
                "htm_liga": "https://hacienda.hidalgo.gob.mx/files/transparencia/htm/2025/Primer%20Trimestre/40-LGT_Art_70_Fr_XL.htm"
            },
           
        ]	
        
    },
    {
        
        "nombre": "41.-Estudios Pagados con Recursos Públcos",
        "icono":"EstudiosPagadosRecursosPublicos.png",
        "formatos": [
            {
                "nombre": "Estudios Pagados con Recursos Públicos ",
                "xlsx": "0",
                "html": "0",
                "xlsx_liga": "https://hacienda.hidalgo.gob.mx/files/transparencia/xlsx/2025/Tercer%20Trimestre/a69_f41_SH.xlsx",
                "htm_liga": "https://hacienda.hidalgo.gob.mx/files/transparencia/htm/2025/Tercer%20Trimestre/a69_f41_SH.htm"
            }
        ]
        
    },
    {
        
        "nombre": "42.-Listados Jubilados y Pensionados",
        "icono":"ListadoJubiladosPencionados.png",
        "formatos": [
            {
                "nombre": "Jubilados y Pensionados",
                "xlsx": "0",
                "html": "0",
                "xlsx_liga": "https://oficialiamayor.hidalgo.gob.mx/Transparencia/xlsx/a69_f42OM.xlsx",
                "htm_liga": "https://oficialiamayor.hidalgo.gob.mx/Transparencia/htm/a69_f42OM.htm"
            },
        
        ]	
        
    },
    {
        
        "nombre": "43.-Ingresos Recibidos por Cualquier Concepto",
        "icono":"IngresosRecibidosCualquierConcepto.png",
        "formatos": [
            {
                "nombre": "Ingresos Recibidos",
                "xlsx": "0",
                "html": "0",
                "xlsx_liga": "https://hacienda.hidalgo.gob.mx/files/transparencia/xlsx/2025/Tercer%20Trimestre/a69_f43_a.xlsx",
                "htm_liga": "https://hacienda.hidalgo.gob.mx/files/transparencia/htm/2025/Tercer%20Trimestre/a69_f43_a.htm"
            },
            {
                "nombre": "Responsables de Recibir los Ingresos",
                "xlsx": "0",
                "html": "0",
                "xlsx_liga": "https://hacienda.hidalgo.gob.mx/files/transparencia/xlsx/2025/Tercer%20Trimestre/a69_f43_b.xlsx",
                "htm_liga": "https://hacienda.hidalgo.gob.mx/files/transparencia/htm/2025/Tercer%20Trimestre/a69_f43_b.htm"
            }
        ]	
        
    },
    {
        
        "nombre": "44.-Donaciones Hechas a Terceros",
        "icono":"DonacionesHechasTerceros.png",
        "formatos": [
            {
                "nombre": "Donaciones en dinero y especie realizadas",
                "xlsx": "2025_a69_f44 SADERH.xlsx",
                "html": "2025_a69_f44 SADERH.htm"
            },
        
        ]	
        
    },
    {
        
        "nombre": "45.-Catálogo Documental y Guia de Archivos",
        "icono":"Viaticos.png",
        "formatos": [
            {
                "nombre": "Inventarios documentales",
                "xlsx": "2025_a69_f45_a SADERH.xlsx",
                "html": "2025_a69_f45_a SADERH.htm"
            },
            {
                "nombre": "Índice de expedientes clasificados",
                "xlsx": "0",
                "html": "0",
                "xlsx_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/xlsx/a69_f45b_SC.xlsx",
                "htm_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/htm/a69_f45b_SC.htm"
            },
            {
                "nombre": "Cuardo General de Clasificción Archivística, Catálogo de disposición documntal, Guía de archivo, Informe Anual de Desarrollo Archivístico,Informe Anual de Cumplimiento, Actas y dictámenes de baja doumental.",
                "xlsx": "2024_a69_f45_c SADERH.xlsx",
                "html": "2024_a69_f45_c SADERH.htm"
            }
        ]
        
    },
    {
        
        "nombre": "46.-Actas de Sesiones, Opiniones y Recomendaciones de Consejos Consultivos",
        "icono":"CatalogoDocumentalGuiaArchivos.png",
        "formatos": [
            {
                "nombre": "Actas del Consejo Consultivo Ciudadano",
                "xlsx": "a69_f46a SADERH.xlsx",
                "html": "a69_f46a SADERH.htm"
            },
            {
                "nombre": "Opiniones del Consejo Consultivo Ciudadano",
                "xlsx": "a69_f46b SADERH.xlsx",
                "html": "a69_f46b SADERH.htm"
            }
        ]	
        
    },
    {
        
        "nombre": "47.-Solicitud de Intervecion de  Comunicaciones",
        "icono":"SolicitudIntervencionComunicaciones.png",
        "formatos": [
            {
                "nombre": "Intervenciones de comunicaciones",
                "xlsx": "0",
                "html": "0",
                "xlsx_liga": "https://procuraduria.hidalgo.gob.mx/Transparencia/xlsx/a69_f47_a_PGJEH.xlsx",
                "htm_liga": "https://procuraduria.hidalgo.gob.mx/Transparencia/htm/a69_f47_a_PGJEH.htm"
            },
            {
                "nombre": "Localización Geográfica",
                "xlsx": "0",
                "html": "0",
                "xlsx_liga": "https://procuraduria.hidalgo.gob.mx/Transparencia/xlsx/a69_f47_b_PGJEH.xlsx",
                "htm_liga": "https://procuraduria.hidalgo.gob.mx/Transparencia/htm/a69_f47_b_PGJEH.htm" 
            },
            
        ]
        
    },
    {
        
        "nombre": "48.-Información de Utilidad o Relevante",
        "icono":"InformacionUtilidadRelevante.png",
        "formatos": [
            {
                "nombre": "Interés Público",
                "xlsx": "a69_f48_a SADERH.xlsx",
                "html": "a69_f48_a SADERH.htm"
            },
            {
                "nombre": "Preguntas Frecuentes",
                "xlsx": "a69_f48_b SADERH.xlsx",
                "html": "a69_f48_b SADERH.htm"
            },
            {
                "nombre": "Transparencia Proactiva",
                "xlsx": "a69_f48_c SADERH.xlsx",
                "html": "a69_f48_c SADERH.htm"
            }
        ]

        
    },
]